export const AnalyticsCardCssString = `
.pt-analytics-card {
    border-radius: 16px;
    height: 208px;
    padding: 24px;
    width: 100%;
    max-width: 308px;
    min-width: 228px;
    position: relative;
    overflow: hidden;
    border: 2px solid #fff;
    background: #fff;
    box-shadow: 0 0 4px 0 rgba(29, 136, 32, 0.08), 0 8px 20px 0 rgba(29, 136, 32, 0.04);
    cursor: pointer;
}

.pt-analytics-card .pt-analytics-card__title {
    line-height: 24px;
    font-size: 16px;
    font-weight: 600;
    height: 48px;
    margin-right: 80px;
}

.pt-analytics-card .pt-analytics-card__title > span {
    white-space: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-wrap: break-word;
}

.pt-analytics-card .pt-analytics-card__img {
    position: absolute;
    right: 0;
    top: 0;
    width: 80px;
    height: 80px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.pt-analytics-card .pt-analytics-card__desc {
    margin-top: 16px;
    line-height: 16px;
    font-size: 12px;
    height: 48px;
    color: #8993a4;
}

.pt-analytics-card .pt-analytics-card__desc > span {
    white-space: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-wrap: break-word;
}

.pt-analytics-card .pt-analytics-card__btn {
    position: relative;
    bottom: -12px;
    padding: 4px 8px 4px 16px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;
    border-radius: 16px;
    color: #fff;
    cursor: pointer;
    width: 100%;
}

.pt-analytics-card .pt-analytics-card__btn-label {
    margin-right: 4px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
}

.pt-analytics-card .pt-analytics-card__btn-icon {
    font-size: 24px;
    margin-bottom: 0;
    color: #fff;
}`;
//# sourceMappingURL=AnalyticsStyle.js.map